"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var TablesDisplayGrid_1 = require("../sharedDisplayGrid/TablesDisplayGrid");
function DatabaseTablesDisplayGrid(props) {
    var cols = __spreadArrays([
        data_catalog_shared_1.createSelectionColumn()
    ], TablesDisplayGrid_1.columns.map(function (columnFactory) { return columnFactory(props); }).filter(function (column) { return column.name !== 'database'; }));
    return (React.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.DatabaseTablesDisplayGrid = DatabaseTablesDisplayGrid;
//# sourceMappingURL=DatabaseTablesDisplayGrid.js.map